var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { DynamicCatalogBuilder } from '../../../builderPackage/components/dynamicCatalogBuilder/dynamicCatalogBuilder';
import { Button, Chip, Link } from '@mui/material';
import { showSurface } from '../../../redux/awaitedSurfacesSlice';
import ActionMenuList from '../../../builderPackage/components/actionsMenuList';
import { useAppDispatch } from '../../../store/hooks';
import { ReactComponent as ViewIcon } from '../../../assets/images/viewIcon.svg';
import { secondary } from '../../../theme/colors';
import { ReactComponent as ShearIcon } from '../../../assets/images/shearIcon.svg';
import { ReactComponent as PrintIcon } from '../../../assets/images/printIcon.svg';
import { useNavigate } from 'react-router-dom';
var JCI_returnCatalogueView = function () {
    var dispatch = useAppDispatch();
    var navigate = useNavigate();
    var moreIconClick = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var MenuList;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(showSurface({
                        type: 'Menu',
                        Component: ActionMenuList,
                        containerProps: {
                            anchorEl: e === null || e === void 0 ? void 0 : e.target,
                            anchorOrigin: {
                                vertical: 'center',
                                horizontal: 'right'
                            },
                            transformOrigin: {
                                vertical: 'top',
                                horizontal: 'right'
                            }
                        },
                        componentProps: {
                            items: [{
                                    id: 'viewInvoice',
                                    children: [/*#__PURE__*/ React.createElement(ViewIcon, {
                                            color: secondary[500],
                                            fontWeight: "medium"
                                        }), "view JC invoice return"]
                                }, {
                                    id: 'ShareInvoice',
                                    children: [/*#__PURE__*/ React.createElement(ShearIcon, {
                                            color: secondary[500],
                                            fontWeight: "medium"
                                        }), "Share Invoice"]
                                }, {
                                    id: 'PrintInvoice',
                                    children: [/*#__PURE__*/ React.createElement(PrintIcon, {
                                            color: secondary[500],
                                            fontWeight: "medium"
                                        }), "Print Invoice"]
                                }]
                        }
                    }))];
                case 1:
                    MenuList = _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var pagingColumns = [{
            field: 'JobCardNo.',
            headerName: 'Job card no.',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.PostingType ? "".concat(row === null || row === void 0 ? void 0 : row.PostingType) : '-'; },
            minWidth: 175
        }, {
            field: 'JobCardInvoiceNo.',
            headerName: 'Job card invoice no.',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.PostingType ? "".concat(row === null || row === void 0 ? void 0 : row.PostingType) : '-'; },
            minWidth: 175
        }, {
            field: 'JCReturnNo.',
            headerName: 'JC return no.',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.JobCardNo ? "".concat(row === null || row === void 0 ? void 0 : row.JobCardNo) : '-'; },
            minWidth: 175,
            renderCell: function (params) {
                var _params$row;
                return /*#__PURE__*/ React.createElement(Button, {
                    sx: {
                        bgcolor: 'transparent'
                    }
                }, params === null || params === void 0 || (_params$row = params.row) === null || _params$row === void 0 ? void 0 : _params$row.JobCardNo);
            }
        }, {
            field: 'JCReturnDate',
            headerName: 'JC return date',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.JobCardNo ? "".concat(row === null || row === void 0 ? void 0 : row.JobCardNo) : '-'; },
            minWidth: 175
        }, {
            field: 'InvoiceDate',
            headerName: 'Invoice date',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.InvoiceDate ? "".concat(row === null || row === void 0 ? void 0 : row.InvoiceDate) : '-'; },
            minWidth: 175
        }, {
            field: 'RegistrationNo.',
            headerName: 'Registration No',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.RegistrationNo ? "".concat(row === null || row === void 0 ? void 0 : row.RegistrationNo) : '-'; },
            minWidth: 175
        }, {
            field: 'PostingType',
            headerName: 'Posting Type',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.CustomerName ? "".concat(row === null || row === void 0 ? void 0 : row.CustomerName) : '-'; },
            minWidth: 175
        }, {
            field: 'ServiceAdvisor',
            headerName: 'Service Advisor',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.MobileNo ? "".concat(row === null || row === void 0 ? void 0 : row.MobileNo) : '-'; },
            minWidth: 175
        }, {
            field: 'InvoiceAmount',
            headerName: 'Invoice Amount',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.InvoiceAmount ? "".concat(row === null || row === void 0 ? void 0 : row.InvoiceAmount) : '-'; },
            minWidth: 175
        }, {
            field: 'CancelAmount',
            headerName: 'Cancel amount',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.OutStandingAmount ? "".concat(row === null || row === void 0 ? void 0 : row.OutStandingAmount) : '-'; },
            minWidth: 175
        }, {
            field: 'Status',
            headerName: 'Status',
            renderCell: function (params) { /*#__PURE__*/ return React.createElement(Chip
            // label={params?.value ?? '-'}
            , {
                label: "Open",
                size: "small",
                variant: "filled",
                color: "primary",
                sx: {
                    borderRadius: 6,
                    px: 1,
                    fontWeight: 'medium',
                    fontSize: 12
                }
            }); },
            minWidth: 100
        }, {
            field: 'actions',
            headerName: 'Actions',
            width: 175,
            headerAlign: 'left',
            disableColumnMenu: true,
            renderCell: function (_ref) {
                var _this = this;
                var row = _ref.row;
                return /*#__PURE__*/ React.createElement(Link, {
                    fontWeight: 'medium',
                    underline: "none",
                    component: 'button',
                    onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            console.log('params', row);
                            navigate("/newJobCardInvoicesReturn");
                            return [2 /*return*/];
                        });
                    }); }
                }, "Return Invoice");
            }
        }];
    var handleRowClick = function (id) {
        navigate("/jobCardInvoicesReturn/JciReturnUpdate/".concat(id === null || id === void 0 ? void 0 : id.id));
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DynamicCatalogBuilder
    // pagingAPIKey={ContractSaleOrderKeys.Paging}
    // getPagingData={ContractSaleOrderPagingAPI}
    // pagingAPIRequest={{
    //     Status: ['Open'],
    //     OrganizationId: userOrganizationID,
    //     ParentOrganizationId: parentOrganizationId,
    //     IdentityId: value?.IdentityId !== "all" ? value?.IdentityId : null,
    //     search: value?.search,
    //     ...value?.Filters
    // }}
    , {
        columns: pagingColumns,
        rows: [{
                "JobCardNo": "JC12345",
                "JobCardINvoiceNo": "INV001",
                "InvoiceDate": "2025-02-14",
                "PostingType": "Service",
                "RegistrationNo": "AB123CD",
                "CustomerName": "John Doe",
                "MobileNo": "+1234567890",
                "InvoiceAmount": 500.75,
                "OutStandingAmount": 100.50,
                "PaymentStatus": "Pending",
                "ServiceAdvisor": "Sarah Lee",
                "JCStatus": "Open",
                "id": "1"
            }, {
                "JobCardNo": "JC12346",
                "JobCardINvoiceNo": "INV002",
                "InvoiceDate": "2025-01-20",
                "PostingType": "Warranty",
                "RegistrationNo": "XY987ZT",
                "CustomerName": "Jane Smith",
                "MobileNo": "+9876543210",
                "InvoiceAmount": 300.40,
                "OutStandingAmount": 0.00,
                "PaymentStatus": "Paid",
                "ServiceAdvisor": "Tom Black",
                "JCStatus": "Closed",
                "id": "2"
            }, {
                "JobCardNo": "JC12347",
                "JobCardINvoiceNo": "INV003",
                "InvoiceDate": "2025-02-10",
                "PostingType": "Parts Replacement",
                "RegistrationNo": "LM567OP",
                "CustomerName": "Alice White",
                "MobileNo": "+1122334455",
                "InvoiceAmount": 750.60,
                "OutStandingAmount": 200.00,
                "PaymentStatus": "Partial Payment",
                "ServiceAdvisor": "Mike Green",
                "JCStatus": "In Progress",
                "id": "3"
            }, {
                "JobCardNo": "JC12348",
                "JobCardINvoiceNo": "INV004",
                "InvoiceDate": "2025-02-01",
                "PostingType": "Repair",
                "RegistrationNo": "CD456EF",
                "CustomerName": "Bob Brown",
                "MobileNo": "+2233445566",
                "InvoiceAmount": 450.00,
                "OutStandingAmount": 50.00,
                "PaymentStatus": "Pending",
                "ServiceAdvisor": "Laura Gray",
                "JCStatus": "Open",
                "id": "4"
            }],
        dataGridProps: {
            sx: {
                m: '0px 16px'
            },
            initialState: {
                pinnedColumns: {
                    right: ["Status", 'actions']
                },
                density: "standard"
            }
        }
    }));
};
export default JCI_returnCatalogueView;
